/*
 *
 * getViewConfig Function
 *
 */

import {getAdministratorBCView, getTenantView} from './getRoleView';
import getSagasConfig from './getSagasConfig';
import createTenantViewSaga from './TenantView/sagas';
import createAdministratorBCViewSaga from './AdministaratorBCView/sagas'
import {role} from "domain/typeConstants/roles";


const defaultViewConfig = {
    createComponent: getTenantView,
    createSaga: (sagaConfig) => createTenantViewSaga(sagaConfig.tenantViewSaga),
};

const viewConfigs = [
    {
        role: role.ADMINISTRATOR_BC,
        createComponent: getAdministratorBCView,
        createSaga: (sagaConfig) => createAdministratorBCViewSaga(sagaConfig.administratorBCViewSaga),
    },
    {
        role: role.TENANT,
        createComponent: getTenantView,
        createSaga: (sagaConfig) => createTenantViewSaga(sagaConfig.tenantViewSaga),
    },
]

export function createViewComponent(userRoles, props) {
    const config = viewConfigs.find((c) => userRoles.includes(c.role));
    if (config) {
        return config.createComponent(props);
    }

    return defaultViewConfig.createComponent(props);
}

export function createViewSaga(userRoles, accountId) {

    const config = viewConfigs.find((c) => userRoles.includes(c.role));
    if (config) {
        return config.createSaga(getSagasConfig(accountId));
    }

    return defaultViewConfig.createSaga(getSagasConfig(accountId));
}
